const onBlurTrim = ({ setValue }) => ({ target: { value, name } }) => {
  setValue(name, value?.trim(), {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true,
  });
};

export default onBlurTrim;
